module.exports = __webpack_public_path__ + "img/icon_exchange.912b071b.svg";